import AutobizModalStyled from './AutobizModalStyled';

export default AutobizModalStyled;
